import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaButtonComponent} from './la-button.component';
import {LaTextModule} from '../text/la-text.module';
import {LaColorService} from '../colors/la-color.service';

export {LaButtonComponent} from './la-button.component';
export {LaColorService} from '../colors/la-color.service';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
    LaTextModule.forRoot()
  ],
  exports: [LaButtonComponent],
  declarations: [LaButtonComponent],
  providers: [LaColorService]
})
export class LaButtonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaButtonModule,
      providers: [LaColorService]
    };
  }
}
